import { cn } from '@shadcn/lib/utils';
import { CalendarCheck, CalendarX } from 'lucide-react';

interface IIconProps {
  readonly className?: string;
}

const CheckmarkIcon = ({ className }: IIconProps) => <CalendarCheck className={cn('text-indigo-500', className)} />;

const EmptyIcon = ({ className }: IIconProps) => <CalendarX className={cn('text-gray-500', className)} />;

const StatusIcon = ({ hasAnswer }: { readonly hasAnswer: boolean }) => (hasAnswer ? <CheckmarkIcon /> : <EmptyIcon />);

export { CheckmarkIcon, EmptyIcon, StatusIcon };
